import { getPreloaderFnContext, query } from '@confluence/query-preloader-tools';
import { fg } from '@confluence/feature-gating';

import { TopNavigationQuery } from './TopNavigationQuery.graphql';
import { preloadUnseenNotificationCount } from './preloadNotificationCount';

export async function preloadTopNavigation() {
	const { userId } = await getPreloaderFnContext();

	const topNavigationPromises = [
		query({
			query: TopNavigationQuery,
			variables: {
				includeEmails:
					fg('confluence_dev_tools_from_flag_icon') || fg('confluence_nav_4_account_menu'),
				includeNav4AdminOptIn: fg('confluence_nav4_ga_phase_1'),
			},
		}),
	];

	if (userId && fg('confluence_frontend_preload_notifications')) {
		//skip for anon
		topNavigationPromises.push(preloadUnseenNotificationCount());
	}

	return Promise.all(topNavigationPromises);
}
